import { useEffect, useState } from 'react';

import { useEventbus } from './useEventbus';

import PreferenceServiceInstance from '@services/PreferenceService';
import type { Team } from '@shared-types/match.types';

export const useUserPreferences = () => {
  const [favouriteTeam, setFavouriteTeam] = useState<Team>(null);
  const [followedTeams, setFollowedTeams] = useState<Team[]>([]);

  // Set initial favourite team
  useEffect(() => {
    setFavouriteTeam(PreferenceServiceInstance.retrievePreferredTeam());
  }, []);

  // Update favourite team
  useEventbus((team: Team) => setFavouriteTeam(team), 'preferredTeamChanged');

  // Set followed teams
  useEffect(() => {
    setFollowedTeams(PreferenceServiceInstance.retrieveFollowedTeams());
  }, []);

  // Update followed team
  useEventbus((teams: Team[]) => setFollowedTeams(teams), 'followingTeamsChanged');

  return {
    favouriteTeam,
    followedTeams,
  };
};
